<template>
<div class="box-labour">
    <div class="box-box">
        <div class="nav">
            <router-link to="HumanDirectory"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
            薪酬福利
            <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
        </div>
        <div class="issueContent">
            <!-- 1. 基本信息及提示 标题 -->
            <div>
                <p class="titleClass">1. 基本信息及提示</p>
                <img v-show="addShowJia" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia()">
                <img v-show="addShowXia" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia()">
            </div>
            <!-- 1. 基本信息及提示 内容 -->
            <div v-for="item in dataList1" :key="item.id" v-show="showContent">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent(item.id)">
            </div>
            <!-- 2. 薪资查询 标题 -->
            <div>
                <p class="titleClass">2. 薪资查询</p>
                <img src="../../assets/you.png" alt="" class="ImgClass ImgClassDian" @click="addgetBtn">
            </div>
            <!-- 2. 薪资查询 内容 -->
            <div v-for="item in dataList2" :key="item.id" v-show="showContent1">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent1(item.id)">
            </div>
            <!-- 3. 员工福利 标题 -->
            <div>
                <p class="titleClass">3. 员工福利</p>
                <img v-show="addShowJia2" src="../../assets/jia.png" alt="" class="ImgClass" @click="addGetJia2()">
                <img v-show="addShowXia2" src="../../assets/xia.png" alt="" class="ImgClass" @click="addGetXia2()">
            </div>
            <!-- 3. 员工福利 内容 -->
            <div v-for="(item, i) in dataList3" :key="i" v-show="showContent2">
                <p class="titleClass titleCotent">{{item.title}}</p>
                <img src="../../assets/dian.png" alt="" class="ImgClass ImgClassDian" @click="addGetContent2(item.id)">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      addShowJia: true,
      addShowXia: false,
      showContent: false,
      addShowJia1: true,
      addShowXia1: false,
      showContent1: false,
      addShowJia2: true,
      addShowXia2: false,
      showContent2: false,
      dataList1: [
        {
          title: "1.1 发薪时间",
          id: "11"
        },
        {
          title: "1.2 计薪周期",
          id: "12"
        },
        {
          title: "1.3 薪酬提示",
          id: "13"
        },
        {
          title: "1.4 绩效提示",
          id: "14"
        },
        {
          title: "1.5 课酬提示",
          id: "15"
        },
        {
          title: "1.6 个人所得税提示",
          id: "16"
        }
      ],
      dataList2: [
        {
          title: "2.1 EHR系统查询流程",
          id: "51"
        },
        {
          title: "2.2 云办公APP查询流程",
          id: "52"
        }
      ],
      dataList3: [
        {
          title: "3.1 法定福利",
          id: "91"
        },
        {
          title: "3.2 节日福利",
          id: "92"
        },
        {
          title: "3.3 生日/结婚/生育福利",
          id: "93"
        },
        {
          title: "3.4 员工年度体检",
          id: "94"
        },
        {
          title: "3.5 员工旅游",
          id: "95"
        },
        {
          title: "3.6 员工报班优惠",
          id: "96"
        },
        {
          title: "3.7 员工推荐奖励",
          id: "97"
        },
        {
          title: "3.8 抚恤",
          id: "98"
        },
        {
          title: "3.9 企业文化微信号",
          id: "99"
        }
      ]
    };
  },
  methods: {
    getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "666"
                }
            })
        },
    addgetBtn(){
      this.$router.push({name:"WelfareRemuneration2"})
    },
    addGetJia() {
      this.addShowXia = true;
      this.showContent = true;
      this.addShowJia = false;
      if (this.addShowJia1 == false || this.addShowXia2 == true) {
        this.addShowJia1 = true;
        this.addShowXia1 = false;
        this.showContent1 = false;
        this.addShowJia2 = true;
        this.addShowXia2 = false;
        this.showContent2 = false;
      }
    },
    addGetXia() {
      this.addShowXia = false;
      this.showContent = false;
      this.addShowJia = true;
    },
    addGetJia1() {
      this.addShowXia1 = true;
      this.showContent1 = true;
      this.addShowJia1 = false;
      if (this.addShowXia == true || this.addShowXia2 == true) {
        this.addShowJia = true;
        this.addShowXia = false;
        this.showContent = false;

        this.addShowJia2 = true;
        this.addShowXia2 = false;
        this.showContent2 = false;
      }
    },
    addGetXia1() {
      this.addShowXia1 = false;
      this.showContent1 = false;
      this.addShowJia1 = true;
    },
    addGetJia2() {
      this.addShowJia2 = false;
      this.addShowXia2 = true;
      this.showContent2 = true;
      if (this.addShowXia == true || this.addShowXia1 == true) {
        this.addShowJia = true;
        this.addShowXia = false;
        this.showContent = false;
        this.addShowJia1 = true;
        this.addShowXia1 = false;
        this.showContent1 = false;
      }
    },
    addGetXia2() {
      this.addShowJia2 = true;
      this.addShowXia2 = false;
      this.showContent2 = false;
    },
    addGetContent(i) {
      if (i == 11 || i == 12 || i == 13 || i == 14) {
        this.$router.push({
          name: "WelfareRemuneration1",
          params: {
            code: "11"
          }
        });
      } else if (i == 15 || i == 16) {
        this.$router.push({
          name: "WelfareRemuneration1",
          params: { code: "12" }
        });
      }
    },
    addGetContent1(i) {
      if (i == 51) {
        this.$router.push({name: "WelfareRemuneration1",params: {code: "1"}
        });
      } else if (i == 52) {
        this.$router.push({ name: "WelfareRemuneration1", params: {code:"2"} });
      }
    },
    addGetContent2(id) {
      if(id == 91){
          this.$router.push({name:"WelfareRemuneration1", params:{code: '91'}})
      } else if(id == 92) {
          this.$router.push({name:"WelfareRemuneration1", params:{code: '92'}})
      } else if(id == 93) {
          this.$router.push({name:"WelfareRemuneration1", params:{code: '93'}})
      } else if(id == 94 || id == 95) {
          this.$router.push({name:"WelfareRemuneration1", params:{code: "94"}})
      } else if(id == 96 || id == 97 || id == 98){
          this.$router.push({name:"WelfareRemuneration1", params:{code: '96'}})
      } else if(id == 99) {
          this.$router.push({name:"WelfareRemuneration1", params:{code: "99"}})
      }
    }
  }, 
  mounted(){}
};
</script>

<style scoped>
.box-labour {
  width: 100%;
  height: 100%;
  background: rgba(244, 244, 244, 1);
}

.box-box {
  background: rgba(244, 244, 244, 1);
}

.nav {
  width: 100%;
  height: 50px;
  background: #11a093;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  position: relative;
  margin-bottom: 17px;
}

.upClass,
.searchClass {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.upClass {
  width: 12px;
  float: left;
  left: 10px;
}

.searchClass {
  width: 19px;
  float: right;
  right: 10px;
}

.issueContent {
  width: 90%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.3);
  border-radius: 10px;
  overflow: hidden;
}

.issueContent div {
  width: 100%;
  height: 56px;
  border-bottom: 1px solid #ededed;
}

.issueContent div:last-child {
    border-bottom: 0;
}

.issueContent div .titleClass {
  width: 86%;
  float: left;
  color: #838383;
  margin: 18px 0 18px 10px;
}

.issueContent div .ImgClassDian {
  width: 18px !important;
}

.issueContent div .titleCotent {
  width: 80% !important;
  margin-left: 24px !important;
  font-size: 15px;
}

.issueContent div img {
  width: 21px;
  float: right;
  margin: 18px 10px 18px 0;
}


</style>



// WEBPACK FOOTER //
// src/components/WelfareRemuneration/welfareRemuneration.vue